/**
 * Experimental
 */
import axios from 'axios';

const directSwapsLoader = async ({ params, request }: any) => {
  const { chain, src, dest } = params;
  const url = `https://api-dev.kattana.trade/direct-swaps/chart/${chain}/${src}/${dest}?period=week&protocol=bancorV3`;
  try {
    const data = await axios.get(url);
    return data.data.reverse();
  } catch (err) {
    console.error(err);
    return null;
  }
};

export default directSwapsLoader;
